export const cdnPath = (path) => {
  // eslint-disable-next-line no-undef
  const tag = process.env.DATE_IMG_TAG
  if (tag) {
    return 'https://cdn.courseticket.com/mf/' + tag + path
  }
  return 'http://localhost:8081' + path
}
export const getTailwindStylesheetUrl = () => cdnPath('/shell/public/styles/tailwind.css')
export const defaultRemoteVersion = 'rc'
export const localRemoteVersion = 'dev'
export const defaultRemoteHost = 'localhost'
export const dockerRemoteHost = 'host.docker.internal'

export const remoteHost = () =>
  // eslint-disable-next-line no-undef
  process.env.REMOTE_HOST || defaultRemoteHost

export const envVarOf = (mfName) => 'MF_' + mfName.replace('mf_', '').toUpperCase()

export const remoteVersionOf = (mfName) =>
  // eslint-disable-next-line no-undef
  process.env[envVarOf(mfName)] || defaultRemoteVersion

export const remoteUrl = (mfName, localPort, svCl) => {
  // eslint-disable-next-line no-undef
  let DATE_IMG_TAG = process.env.DATE_IMG_TAG
  const remoteVersion = remoteVersionOf(mfName)
  if (DATE_IMG_TAG || remoteVersion !== localRemoteVersion) {
    if (!DATE_IMG_TAG) {
      DATE_IMG_TAG = remoteVersion
    }
    const domain = 'https://cdn.courseticket.com/mf/'
    return domain + DATE_IMG_TAG + '/' + mfName + '/' + svCl + '/'
  }
  const host = svCl === 'client' ? defaultRemoteHost : remoteHost()
  // eslint-disable-next-line no-console
  console.log(`🧩  Microfrontend loaded via "${host}" for ${svCl}: ${mfName}`)
  return 'http://' + host + ':' + localPort + '/' + svCl + '/'
}
export const remote = (mfName, localPort, svCl) => {
  return mfName + '@' + remoteUrl(mfName, localPort, svCl) + 'remoteEntry.js'
}
